import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VaccinConsultationItem } from 'src/app/entities/consultation.entity';
export class VaccinFilter {
  vaccinConsultation:  VaccinConsultationItem;
  selected: boolean;
  index: number
  constructor(other?: Partial<VaccinFilter>) {
    this.vaccinConsultation = other?.vaccinConsultation || new VaccinConsultationItem();
    this.selected = other?.selected || false;
    this.index = other?.index || 0
  }
}
@Component({
  selector: 'app-vaccin-select-drawer',
  templateUrl: './vaccin-select-drawer.component.html',
  styleUrls: ['./vaccin-select-drawer.component.css']
})
export class VaccinSelectDrawerComponent implements OnInit {
 @Input() values: Array<any> = new Array();
  @Output() valuesChange: EventEmitter<any> = new EventEmitter();
  isChecked: boolean = false;
  vaccins: string = "";
  select: Array<VaccinFilter> = []
  @Input() vaccinsSelected: Array<VaccinFilter> = new Array();
  @Output() vaccinsSelectedChange: EventEmitter<Array<VaccinFilter>> = new EventEmitter();
  @Output() closed: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }

  changed(vaccin: any, event, index): void {
    if (event.target.checked == true) {
      this.vaccinsSelected.push({ vaccinConsultation: new VaccinConsultationItem({vaccin:vaccin}), selected: event.target.checked, index: index });

      this.vaccinsSelectedChange.emit(this.vaccinsSelected.filter((elm) => elm.vaccinConsultation.vaccin.nom_Vaccin !== ''));

    } else {
      this.vaccinsSelected = this.vaccinsSelected.filter((elm) => elm.vaccinConsultation.vaccin !== vaccin && elm.selected != false);

      this.vaccinsSelectedChange.emit(this.vaccinsSelected);
    }

  }
  close(): void {
    this.vaccinsSelectedChange.emit(this.vaccinsSelected);

    this.closed.emit();
  }


}
